export const appVersion = __APP_VERSION__;
